// extracted by mini-css-extract-plugin
module.exports = {"sponsoredHeaderWrapper":"SponsoredHeader_sponsoredHeaderWrapper__84lE2","imageWrapper":"SponsoredHeader_imageWrapper__8f5wC"};